// Featured CI Expert — Dr. Sanjay Sachdeva
// Public info sourced from drssachdeva.com and Max Healthcare public profile

export const FEATURED_DOCTOR = {
  slug: "dr-sanjay-sachdeva",
  name: "Dr. Sanjay Sachdeva",
  title: "Senior ENT Consultant & Cochlear Implant Surgeon",
  position: "Principal Director — ENT, Head & Neck Surgery",
  affiliations: [
    "Max Super Speciality Hospital, Saket, New Delhi",
    "Max Multi Speciality Centre, Panchsheel Park, New Delhi",
    "Private Clinic — B-163, Greater Kailash Part I, New Delhi",
  ],
  qualifications: [
    "MBBS, DCH, MS (ENT) — Maulana Azad Medical College, New Delhi",
    "Fellowship, Nucleus Cochlear Institute — Australia",
    "Fellowship, University of Würzburg — Germany",
  ],
  years_experience: "35+ years",
  specialties: [
    "Cochlear Implant Surgery",
    "Skull Base Surgery",
    "Snoring & Obstructive Sleep Apnea",
    "Vertigo",
    "Nasal & Sinus Surgery",
    "BAHA (Bone-Anchored Hearing Aid)",
  ],
  memberships: [
    "Cochlear Implant Group of India",
    "Skull Base Society of India",
    "Association of Otolaryngologists of India",
  ],
  bio: [
    "Dr. Sanjay Sachdeva is a distinguished Senior ENT Consultant based in Delhi with over 35 years of clinical experience. He currently serves as Principal Director of ENT and Head & Neck Surgery at Max Healthcare, and is widely recognised as one of India's most experienced cochlear implant surgeons.",
    "His clinical approach to cochlear implantation is comprehensive — involving a multidisciplinary team of audiologists, speech therapists and ENT specialists — so that families receive complete guidance from diagnosis through switch-on and lifelong follow-up.",
    "Beyond his surgical practice, he founded the Ripudaman Charitable Trust to support children with hearing loss through early screening, cochlear implant surgery and structured rehabilitation.",
  ],
  photo: "https://drssachdeva.com/wp-content/uploads/2024/12/LOWX0076-1024x685.jpg",
  photoAlt: "Dr. Sanjay Sachdeva — Senior ENT Consultant and Cochlear Implant Surgeon",
  clinicSourceUrl: "https://drssachdeva.com/",
  maxProfileUrl: "https://www.maxhealthcare.in/doctor/dr-sanjay-sachdeva",
  contact: {
    phones: ["+91 99103 17286", "+91 98101 53116"],
    email: "entdrsachdeva25@gmail.com",
    clinic_address: "B-163, Greater Kailash Part I, New Delhi 110048",
    clinic_hours: "Monday to Saturday, 10:00 AM – 7:00 PM",
  },
  videos: [
    {
      title: "About Dr. Sanjay Sachdeva",
      caption: "A short introduction to Dr. Sachdeva's cochlear implant practice and philosophy of care.",
      url: "https://customer-assets-39nsmqrw.emergentagent.net/job_implant-care-india/artifacts/pfggwqk7_157e74e9-315b-4f76-b3c9-3809a6c07c1a.MP4",
      poster:
        "https://images.unsplash.com/photo-1651002520565-b27c9f2b58ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxoZWFyaW5nJTIwZG9jdG9yfGVufDB8fHx8MTc4MTQ4OTEzOHww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Cochlear Implant — Doctor Explains",
      caption: "Dr. Sachdeva explains how a cochlear implant works and who it can help.",
      url: "https://customer-assets-39nsmqrw.emergentagent.net/job_implant-care-india/artifacts/a3hbbd5p_157e74e9-315b-4f76-b3c9-3809a6c07c1a%202.MP4",
      poster:
        "https://images.unsplash.com/photo-1596088728260-08a654466a00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxoZWFyaW5nJTIwZG9jdG9yfGVufDB8fHx8MTc4MTQ4OTEzOHww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Patient Journey",
      caption: "A patient's cochlear implant journey under Dr. Sachdeva's care.",
      url: "https://customer-assets-39nsmqrw.emergentagent.net/job_implant-care-india/artifacts/b2ig72vc_9d37897d-4ae4-44df-89c0-63fb19b30bdd.MP4",
      poster:
        "https://images.unsplash.com/photo-1603367563698-67012943fd67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Post-Implant Rehabilitation",
      caption: "Dr. Sachdeva on why therapy after cochlear implant is as important as surgery itself.",
      url: "https://customer-assets-39nsmqrw.emergentagent.net/job_implant-care-india/artifacts/hv9bigql_8eb90526-4327-421d-ae79-a858425074c1.MP4",
      poster:
        "https://images.unsplash.com/photo-1632053002928-1919605ee6f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwZWRpYXRyaWNpYW4lMjBjaGlsZHxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Family Testimonial",
      caption: "A family shares their experience with Dr. Sachdeva's team.",
      url: "https://customer-assets-39nsmqrw.emergentagent.net/job_implant-care-india/artifacts/wiv4lzz9_2e32c9b1-ab93-4e0d-a5d1-ff02b972f6c1.MP4",
      poster:
        "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
    },
  ],
  testimonials: [
    {
      name: "Vaishav Sharma",
      quote:
        "He is undoubtedly one of the best doctors I have come across. His extensive experience is evident not only in his professional behaviour but also in the precision and effectiveness of his medical procedures.",
    },
    {
      name: "Pratima Tiwari",
      quote:
        "One of the best doctors I have come across. His vast experience reflects in his compassionate demeanour and the precision of his procedures. The confidence he instils and the exceptional care he provides make him stand out.",
    },
    {
      name: "Rahul Gupta",
      quote:
        "My 5-year-old son was suggested grommet insertion by all other ENT doctors. Dr Sanjay helped him heal through medication only. He was polite and answered all our questions patiently.",
    },
  ],

  // Anonymised switch-on stories — composite illustrative narratives
  // inspired by paediatric cases in Dr. Sachdeva's practice.
  // No identifying patient photographs are used.
  switch_on_moments: [
    {
      alias: "Aarav, 3",
      city: "Delhi",
      moment: "First 'Amma' after switch-on",
      story:
        "Born with profound hearing loss. Bilateral implant at 2y 8m. Six weeks after switch-on, he called out to his mother for the first time — mid-therapy session.",
      image:
        "https://images.unsplash.com/photo-1603367563698-67012943fd67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      alias: "Meher, 4",
      city: "Chandigarh",
      moment: "Now attends mainstream school",
      story:
        "Diagnosed at 18 months. Implanted at 2y 3m. After 18 months of auditory-verbal therapy, she started mainstream nursery with a normal-hearing peer group.",
      image:
        "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMGNoaWxkfGVufDB8fHx8MTc4MTQ4OTE0M3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      alias: "Vihaan, 2",
      city: "Lucknow",
      moment: "Turned to a doorbell — first ever",
      story:
        "Late diagnosis at 20 months. Family travelled to Delhi for surgery under ADIP. Two days after switch-on, he startled at the doorbell — his first behavioural response to sound.",
      image:
        "https://images.unsplash.com/photo-1708687045030-26702e62fc65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwZWRpYXRyaWNpYW4lMjBjaGlsZHxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      alias: "Anaya, 5",
      city: "Jaipur",
      moment: "Sang her first rhyme",
      story:
        "Sequential bilateral implant. After 24 months of AVT, sang 'Twinkle Twinkle' end-to-end at her school annual day — an outcome her parents could not have imagined at diagnosis.",
      image:
        "https://images.unsplash.com/photo-1632053002928-1919605ee6f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwZWRpYXRyaWNpYW4lMjBjaGlsZHxlbnwwfHx8fDE3ODE0ODkxMzh8MA&ixlib=rb-4.1.0&q=85",
    },
  ],

  // Career highlights — assembled from publicly available profiles
  // (drssachdeva.com, Max Healthcare public page).
  career_highlights: [
    {
      year: "1988",
      title: "MBBS — Maulana Azad Medical College",
      detail:
        "Completed undergraduate medical training at MAMC, one of India's leading government medical colleges.",
    },
    {
      year: "Early 1990s",
      title: "MS (ENT) — Maulana Azad Medical College",
      detail:
        "Post-graduate specialisation in Otorhinolaryngology, laying the foundation for a lifelong focus on ear and hearing surgery.",
    },
    {
      year: "1990s",
      title: "International Fellowship — Nucleus Cochlear Institute, Australia",
      detail:
        "Dedicated fellowship in cochlear implant surgery at Cochlear's founding institute — one of a handful of Indian ENT surgeons trained there in that era.",
    },
    {
      year: "1990s",
      title: "Fellowship — University of Würzburg, Germany",
      detail:
        "Advanced training in skull-base and otology surgery at a European academic centre.",
    },
    {
      year: "2000s onwards",
      title: "Principal Director — ENT, Head & Neck Surgery, Max Healthcare",
      detail:
        "Leads the ENT and cochlear implant service at Max Super Speciality Hospital, Saket and Max Multi Speciality Centre, Panchsheel Park.",
    },
    {
      year: "Ongoing",
      title: "Founder — Ripudaman Charitable Trust",
      detail:
        "Founded a charitable trust that supports early hearing screening, cochlear implant surgery and structured rehabilitation for children from underprivileged families.",
    },
    {
      year: "Ongoing",
      title: "Active Member — Cochlear Implant Group of India, Skull Base Society of India, AOI",
      detail:
        "Long-standing membership of India's leading academic bodies for cochlear implantation, skull-base surgery and otolaryngology.",
    },
    {
      year: "Ongoing",
      title: "Patient-facing education & family counselling",
      detail:
        "Publishes short explainer videos on cochlear implants and family-centred rehabilitation, and personally leads pre-operative counselling for every CI family.",
    },
  ],
};
